import _ from 'lodash';
import moment from 'moment';
import { api } from '../api';

function generateActionHash() {
  let actionHash = Math.floor(Math.random() * Date.now() / Math.random() * 10000);

  while (actionHash > 9223372036854775807) { // limit of bigint
    actionHash = Math.floor(Math.random() * Date.now() / Math.random() * 10000);
  }

  return actionHash;
}
function prepareEventsData(data) {
  const momentToNumber = date => +moment(date);

  const preparedDataNoHash = data
    .filter(obj => !obj.action_hash)
    .map(event => ({
      ...event,
      text: __(event.action_description.locale, event.action_description.data),
    }));

  const preparedDataWithHash = _.chain(
    _.filter(data, obj => !!obj.action_hash && +obj.action_id !== 43),
  )
    .groupBy('action_hash')
    .map((events, key) => {
      const mainEvent = _.find(events, event => !event.action_description.isSystem && !event.action_description.isHidden);
      let lastEvent = _.findLast(events, event => event.action_description.isSystem || event.action_description.isHidden);

      const eventText = mainEvent
        ? __(mainEvent.action_description.locale, mainEvent.action_description.data)
        : __(lastEvent.action_description.locale, lastEvent.action_description.data);

      if (!lastEvent) {
        lastEvent = mainEvent;
        lastEvent.withHash = false;
      } else {
        lastEvent.withHash = true;
      }

      if (mainEvent) {
        lastEvent.action_id = mainEvent.action_id;
        lastEvent.action_description = mainEvent.action_description;
        lastEvent.created_at = mainEvent.created_at;
        lastEvent.user_pic = mainEvent.user_pic;
        lastEvent.user_id = mainEvent.user_id;
        lastEvent.user_name = mainEvent.user_name;
      }

      lastEvent.text = eventText;
      lastEvent.searchText = eventText.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');

      return lastEvent;
    })
    .value();

  return _.orderBy(
    [...preparedDataNoHash, ...preparedDataWithHash],
    event => momentToNumber(event.created_at),
    'desc',
  );
}
function prepareLoadedEvents(data) {
  const finishData = [];
  let currentDay = false;
  const _data = prepareEventsData(data);

  _.each(_data, item => {
    if (+item.action_description.isHidden) {
      return;
    }

    const cDate = item.created_at.substring(0, 10);

    if (!currentDay || currentDay !== cDate) {
      currentDay = cDate;
      finishData.push({
        id: generateActionHash(),
        customTemplate: true,
        value: currentDay,
      });
    }

    finishData.push(item);
  });

  return finishData;
}

const HistoryStore = {
  namespaced: true,
  state: {
    events: [],
    prevFrom: null,
  },
  getters: {
    getEvents: state => state.events,
    prevFrom: state => state.prevFrom,
  },
  mutations: {
    setLoadedEvents(state, payload) {
      state.events = payload.events;
    },
    setPrevFrom(state, payload) {
      state.prevFrom = payload;
    },
    resetState(state) {
      state.events = [];
      state.prevFrom = null;
    },
  },
  actions: {
    async loadData({ commit }, payload) {
      return api.get(`/history/gantt_id/${payload.ganttId}?${Date.now()}&offset=0&limit=3000`).then(response => {
        if (response?.data?.length) {
          const events = prepareLoadedEvents(response.data);

          commit('setLoadedEvents', { events });
        }
      });
    },
    reloadHistory({ state }, payload) {
      api.post(`/history/event/${payload.eventId}`, { gantt_id: payload.ganttId }).then(r => {
        const route = window.location.href;
        const prevMode = state.prevFrom || 'gantt';
        const newUrl = route.replace(/\/[^\/]+$/, `/${prevMode}`);

        window.history.pushState({}, '', newUrl);
        window.location.reload(false);
      });
    },
    resetState({ commit }) {
      commit('resetState');
    },
  },
};

export default HistoryStore;
